import { KEY_CONSTS } from './constants'

export const isEnterKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return (
    key === KEY_CONSTS.ENTER_NUMBER_KEY || key === KEY_CONSTS.ENTER_STRING_KEY
  )
}

export const isSpaceKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return (
    key === KEY_CONSTS.SPACE_NUMBER_KEY || key === KEY_CONSTS.SPACE_STRING_KEY
  )
}

export const isEscKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return (
    key === KEY_CONSTS.ESCAPE_STRING_KEY || key === KEY_CONSTS.ESCAPE_NUMBER_KEY
  )
}

export const isRightKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return (
    key === KEY_CONSTS.ARROW_RIGHT_NUMBER_KEY ||
    key === KEY_CONSTS.ARROW_RIGHT_STRING_KEY
  )
}

export const isLeftKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return (
    key === KEY_CONSTS.ARROW_LEFT_NUMBER_KEY ||
    key === KEY_CONSTS.ARROW_LEFT_STRING_KEY
  )
}

export const isTabKey = (event: KeyboardEvent) => {
  const key = event.key || event.keyCode
  return key === KEY_CONSTS.TAB_NUMBER_KEY || key === KEY_CONSTS.TAB_STRING_KEY
}
